import { render } from "./DealPriceDetail.vue?vue&type=template&id=8b945bfc&scoped=true"
import script from "./DealPriceDetail.vue?vue&type=script&lang=js"
export * from "./DealPriceDetail.vue?vue&type=script&lang=js"

import "./DealPriceDetail.vue?vue&type=style&index=0&id=8b945bfc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b945bfc"]])

export default __exports__